import { is } from 'ramda';

export const vertical = (val = 20) => [val, 0];
export const horizontal = (val = 20) => [0, val];
export const topAndHorizontal = (val = 20) => [val, val, 0, val];
export const bottomAndHorizontal = (val = 20) => [0, val, val, val];
export const onlyTop = (val = 5) => [val, val, 0, 0];
export const onlyBottom = (val = 5) => [0, 0, val, val];
export const onlyLeft = (val = 5) => [val, 0, 0, val];
export const onlyRight = (val = 5) => [0, val, val, 0];
export const border = (color: string, size = 1, type = 'solid') => `${size}px ${type} ${color}`;
export const transition = (timingInMs = 150, property = 'all', mode = 'linear') =>
  `${property} ${timingInMs}ms ${mode}`;

export const setProp = (obj: any, key: string, value: string | number) => {
  if (value) {
    obj[key] = value;
  }

  return obj;
};

export const toCssValue = (
  value: number | 'auto' | (number | 'auto')[],
  important = false,
): string => {
  let cssRule;

  if (is(Array, value)) {
    cssRule = (value as (number | 'auto')[])
      .map((v) => (is(Number, v) ? ` ${v}px` : ` ${v}`))
      .join(' ');
  } else {
    cssRule = is(Number, value) ? `${value}px` : value;
  }
  if (important) {
    cssRule += ' !important';
  }

  return cssRule.toString();
};
